(function () {
  const WIDTHS_KOMPLETTSET = [
    10.0, 12.5, 15.0, 17.5, 20.0, 22.5, 25.0, 27.5, 30.0,
    32.5, 35.0, 37.5, 40.0, 42.5, 45.0, 47.5, 50.0
  ];

  function widthKey(value) {
    return Number(value).toFixed(1);
  }

  function round2(value) {
    return Math.round((Number(value) + Number.EPSILON) * 100) / 100;
  }

  function generateLinearPriceTable(basePriceAt10m, stepPer2_5m) {
    const table = {};
    WIDTHS_KOMPLETTSET.forEach((width, index) => {
      table[widthKey(width)] = round2(basePriceAt10m + stepPer2_5m * index);
    });
    return table;
  }

  function buildKomplettsetProfile(baseMap, stepMap) {
    const result = {};
    Object.keys(baseMap).forEach((height) => {
      result[String(height)] = generateLinearPriceTable(baseMap[height], stepMap[height]);
    });
    return result;
  }

  // EINZELMATTEN: Preis pro Matte je Höhe
  const doppelstabEinzelmatten656Standard = {
    "630": 23.40,
    "830": 29.25,
    "1030": 35.10,
    "1230": 40.95,
    "1430": 46.80,
    "1630": 52.65,
    "1830": 58.50,
    "2030": 64.35
  };

  const doppelstabEinzelmatten656Feuerverzinkt = {
    "630": 33.43,
    "830": 41.79,
    "1030": 50.14,
    "1230": 58.50,
    "1430": 66.86,
    "1630": 75.21,
    "1830": 83.57,
    "2030": 91.93
  };

  const doppelstabEinzelmatten868Standard = {
    "630": 34.45,
    "830": 43.55,
    "1030": 52.00,
    "1230": 61.10,
    "1430": 70.20,
    "1630": 79.30,
    "1830": 88.40,
    "2030": 97.50
  };

  const doppelstabEinzelmatten868Feuerverzinkt = {
    "630": 49.21,
    "830": 62.21,
    "1030": 74.29,
    "1230": 87.29,
    "1430": 100.29,
    "1630": 113.29,
    "1830": 126.29,
    "2030": 139.28
  };

  // KOMPLETTSET 6/5/6 LIGHT
  const komplettset656Light = buildKomplettsetProfile(
    {
      "630": 158.4,
      "830": 186.0,
      "1030": 213.6,
      "1230": 244.2,
      "1430": 277.8,
      "1630": 317.4,
      "1830": 348.0,
      "2030": 381.6
    },
    {
      "630": 36.0,
      "830": 42.6,
      "1030": 49.2,
      "1230": 56.4,
      "1430": 64.2,
      "1630": 73.2,
      "1830": 80.4,
      "2030": 88.2
    }
  );

  // KOMPLETTSET 6/5/6 PREMIUM
  const komplettset656Premium = buildKomplettsetProfile(
    {
      "630": 191.4,
      "830": 225.0,
      "1030": 261.6,
      "1230": 295.2,
      "1430": 334.8,
      "1630": 368.4,
      "1830": 408.0,
      "2030": 441.6
    },
    {
      "630": 42.6,
      "830": 50.4,
      "1030": 58.8,
      "1230": 66.6,
      "1430": 75.6,
      "1630": 83.4,
      "1830": 92.4,
      "2030": 100.2
    }
  );

  // KOMPLETTSET 8/6/8 LIGHT
  const komplettset868Light = buildKomplettsetProfile(
    {
      "630": 199.2,
      "830": 238.8,
      "1030": 276.0,
      "1230": 318.6,
      "1430": 364.2,
      "1630": 415.8,
      "1830": 458.4,
      "2030": 504.0
    },
    {
      "630": 45.0,
      "830": 54.0,
      "1030": 62.4,
      "1230": 72.0,
      "1430": 82.2,
      "1630": 93.6,
      "1830": 103.2,
      "2030": 113.4
    }
  );

  // KOMPLETTSET 8/6/8 PREMIUM
  const komplettset868Premium = buildKomplettsetProfile(
    {
      "630": 232.2,
      "830": 277.8,
      "1030": 324.0,
      "1230": 369.6,
      "1430": 421.2,
      "1630": 466.8,
      "1830": 518.4,
      "2030": 564.0
    },
    {
      "630": 52.8,
      "830": 63.6,
      "1030": 73.8,
      "1230": 84.0,
      "1430": 95.4,
      "1630": 105.6,
      "1830": 117.0,
      "2030": 127.2
    }
  );

  window.ZAUN_PREISE = {
    helpers: {
      normalizeWidthKey(value) {
        const num = Number(String(value).replace(',', '.'));
        if (Number.isNaN(num)) return '';
        return num.toFixed(1);
      },

      resolveIndustry9Variant(rawValue) {
        const value = String(rawValue || '').toLowerCase();
        if (
          value.includes('antrieb') ||
          value.includes('hohen schrank') ||
          value.includes('hochschrank')
        ) {
          return 'antrieb_im_hohen_schrank';
        }
        return 'manual';
      }
    },

    doppelstab: {
      einzelmatten: {
        "656": {
          standard: doppelstabEinzelmatten656Standard,
          feuerverzinkt: doppelstabEinzelmatten656Feuerverzinkt
        },
        "868": {
          standard: doppelstabEinzelmatten868Standard,
          feuerverzinkt: doppelstabEinzelmatten868Feuerverzinkt
        }
      },

      komplettset: {
        "656": {
          light: komplettset656Light,
          premium: komplettset656Premium
        },
        "868": {
          light: komplettset868Light,
          premium: komplettset868Premium
        }
      }
    },

    schiebetor: {
      manual: {
        "830": {
          "3.0": 1668.60,
          "3.5": 1723.50,
          "4.0": 1994.49,
          "4.5": 2118.60,
          "5.0": 2392.20,
          "5.5": 2497.50,
          "6.0": 2604.60
        },
        "1030": {
          "3.0": 1730.70,
          "3.5": 1786.50,
          "4.0": 2072.70,
          "4.5": 2198.70,
          "5.0": 2490.30,
          "5.5": 2599.20,
          "6.0": 2709.00
        },
        "1230": {
          "3.0": 1859.40,
          "3.5": 1918.80,
          "4.0": 2240.10,
          "4.5": 2377.80,
          "5.0": 2588.40,
          "5.5": 2703.60,
          "6.0": 2813.40
        },
        "1430": {
          "3.0": 1924.20,
          "3.5": 1986.30,
          "4.0": 2322.00,
          "4.5": 2463.30,
          "5.0": 2895.30,
          "5.5": 3239.10,
          "6.0": 3368.70
        },
        "1630": {
          "3.0": 1989.90,
          "3.5": 2052.90,
          "4.0": 2306.70,
          "4.5": 2651.40,
          "5.0": 3213.90,
          "5.5": 3356.10,
          "6.0": 3488.40
        },
        "1830": {
          "3.0": 2057.40,
          "3.5": 2123.10,
          "4.0": 2387.70,
          "4.5": 2744.10,
          "5.0": 3109.50,
          "5.5": 3969.90,
          "6.0": 4089.60
        },
        "2030": {
          "4.5": 2834.10,
          "5.0": 3445.20,
          "5.5": 3969.90,
          "6.0": 4089.60
        }
      },

      electric: {
        "830": {
          "3.0": 2799.90,
          "3.5": 2853.90,
          "4.0": 3124.80,
          "4.5": 3249.00,
          "5.0": 3523.50,
          "5.5": 3628.80,
          "6.0": 3735.90
        },
        "1030": {
          "3.0": 2862.00,
          "3.5": 2917.80,
          "4.0": 3203.10,
          "4.5": 3300.00,
          "5.0": 3620.70,
          "5.5": 3730.50,
          "6.0": 3839.40
        },
        "1230": {
          "3.0": 2989.80,
          "3.5": 3050.10,
          "4.0": 3371.40,
          "4.5": 3508.20,
          "5.0": 3719.70,
          "5.5": 3834.00,
          "6.0": 3944.70
        },
        "1430": {
          "3.0": 3055.50,
          "3.5": 3117.60,
          "4.0": 3453.30,
          "4.5": 3594.60,
          "5.0": 4025.70,
          "5.5": 4369.50,
          "6.0": 4499.10
        },
        "1630": {
          "3.0": 3121.20,
          "3.5": 3184.20,
          "4.0": 3603.30,
          "4.5": 3782.70,
          "5.0": 4345.20,
          "5.5": 4487.40,
          "6.0": 4618.80
        },
        "1830": {
          "3.0": 3188.70
        },
        "2030": {
          "3.0": 3253.30,
          "3.5": 3321.00,
          "4.0": 3765.60,
          "4.5": 3964.50,
          "5.0": 4576.50,
          "5.5": 6700.50,
          "6.0": 6700.50
        }
      },

      industry9: {
        manual: {
          "1000": {
            "6.0": 5006.00,
            "6.5": 5488.00,
            "7.0": 5638.00,
            "7.5": 5660.00,
            "8.0": 5837.00
          },
          "1200": {
            "6.0": 5102.00,
            "6.5": 5594.00,
            "7.0": 5746.00,
            "7.5": 5773.00,
            "8.0": 5992.00,
            "8.5": 6218.00,
            "9.0": 6410.00
          },
          "1400": {
            "6.0": 5201.00,
            "6.5": 5702.00,
            "7.0": 5858.00,
            "7.5": 5887.00,
            "8.0": 6071.00,
            "8.5": 6343.00,
            "9.0": 6537.00
          },
          "1600": {
            "6.0": 5308.00,
            "6.5": 5818.00,
            "7.0": 5977.00,
            "7.5": 6010.00,
            "8.0": 6202.00,
            "8.5": 6476.00,
            "9.0": 6676.00
          },
          "1800": {
            "6.0": 5582.00,
            "6.5": 6115.00,
            "7.0": 6281.00,
            "7.5": 6323.00,
            "8.0": 6531.00,
            "8.5": 6817.00,
            "9.0": 9283.00
          },
          "2000": {
            "6.0": 5908.00,
            "6.5": 6613.00,
            "7.0": 6792.00,
            "7.5": 6849.00,
            "8.0": 7078.00,
            "8.5": 6917.00,
            "9.0": 10071.00
          }
        },

        antrieb_im_hohen_schrank: {
          "1000": {
            "6.0": 8252.00,
            "6.5": 8734.00,
            "7.0": 8884.00,
            "7.5": 8906.00,
            "8.0": 9083.00
          },
          "1200": {
            "6.0": 8348.00,
            "6.5": 8840.00,
            "7.0": 8992.00,
            "7.5": 9019.00,
            "8.0": 9198.00,
            "8.5": 9464.00,
            "9.0": 9656.00
          },
          "1400": {
            "6.0": 8447.00,
            "6.5": 8948.00,
            "7.0": 9104.00,
            "7.5": 9133.00,
            "8.0": 9317.00,
            "8.5": 9589.00,
            "9.0": 9783.00
          },
          "1600": {
            "6.0": 8554.00,
            "6.5": 9064.00,
            "7.0": 9223.00,
            "7.5": 9256.00,
            "8.0": 9448.00,
            "8.5": 9722.00,
            "9.0": 9922.00
          },
          "1800": {
            "6.0": 8828.00,
            "6.5": 9361.00,
            "7.0": 9527.00,
            "7.5": 9569.00,
            "8.0": 9777.00,
            "8.5": 10063.00,
            "9.0": 13285.00
          },
          "2000": {
            "6.0": 9154.00,
            "6.5": 9859.00,
            "7.0": 10038.00,
            "7.5": 10095.00,
            "8.0": 10324.00,
            "8.5": 10163.00,
            "9.0": 14073.00
          }
        }
      },

      industry16: {
        preis_auf_anfrage: true
      }
    }
  };
})();